import { render } from "./Versions.vue?vue&type=template&id=463d8fe1&ts=true"
import script from "./Versions.vue?vue&type=script&lang=ts"
export * from "./Versions.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__